import * as stylex from '@stylexjs/stylex';
import type { StyleXStyles } from '@stylexjs/stylex';
import { stylexProps } from '@/util/stylexProps';

type Props = Omit<React.HTMLProps<HTMLParagraphElement>, 'style' | 'className'> & {
  variant?: 'base' | 'small';
  style?: StyleXStyles;
  className?: string;
};

const PFParagraph = (props: Props) => {
  const { variant = 'base', style, className, children, ...rest } = props;
  return (
    <p
      {...rest}
      {...stylexProps(
        className ? `pfParagraph ${className}` : 'pfParagraph',
        styles.base,
        variant === 'base' && styles.variantBase,
        variant === 'small' && styles.variantSmall,
        style,
      )}
    >
      {children}
    </p>
  );
};

const styles = stylex.create({
  base: {
    paddingBlock: 12,
    paddingInline: 0,
  },
  variantBase: {
    lineHeight: {
      default: '30px',
      ['@media (min-width: 640px)']: '38px',
    },
    fontSize: {
      default: 'inherit',
      ['@media (min-width: 640px)']: 22,
    },
  },
  variantSmall: {
    fontSize: {
      default: 16,
      ['@media (min-width: 640px)']: 18,
    },
    lineHeight: {
      default: '24px',
      ['@media (min-width: 640px)']: '32px',
    },
  },
});

export default PFParagraph;
